export interface InstanceStatusBadge {
  statusLabel: string
  statusClass: string
}

export function instanceStatusBadge(status: string): InstanceStatusBadge {
  const label = status ? status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ') : 'Unknown'
  let statusClass = 'bg-gray-100 text-gray-600'
  if (['scored', 'completed', 'submitted'].includes(status))
    statusClass = 'bg-[#DBF6E5] text-[#118D57]'
  else if (['in_progress', 'ready_to_start'].includes(status))
    statusClass = 'bg-[#E0F2FE] text-[#0369A1]'
  else if (status === 'overtime')
    statusClass = 'bg-[#FFF5CC] text-[#B76E00]'
  else if (['past_due', 'out_of_time', 'too_late_to_start', 'retake_locked'].includes(status))
    statusClass = 'bg-[#FBEBEF] text-[#CC0033]'
  return { statusLabel: label, statusClass }
}
